export default [
    {
        path: 'assinatura-eletronica',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-assinatura-eletronica' */
            '@/views/exame-laboratorial/assinatura-eletronica/Index'
        ),
        redirect: 'assinatura-eletronica/index',
        children: [
            {
                name: 'exame-laboratorial-assinatura-eletronica-index',
                path: 'index',
                meta: { keepAlive: true },
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-assinatura-eletronica' */
                    '@/views/exame-laboratorial/assinatura-eletronica/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-assinatura-eletronica-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id), profissionalId: parseInt(route.params.profissionalId) }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-assinatura-eletronica' */
                    '@/views/exame-laboratorial/assinatura-eletronica/Form.vue'
                ),
            },
        ],
    }
]